/**
 * Gera um UUID v4 aleatório
 * @returns {string} UUID no formato xxxxx-xxxxx-xxxxx-xxxxx-xxxxx
 */
export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Gera um token aleatório em Base64
 * @param {number} length - Tamanho do token em bytes (padrão: 32)
 * @returns {string} Token codificado em Base64
 */
export const generateTokenBase64 = (length = 32) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  let token = "";
  for (let i = 0; i < length; i++) {
    token += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token;
};

/**
 * Gera um token aleatório seguro (alphanumeric)
 * @param {number} length - Tamanho do token (padrão: 32)
 * @returns {string} Token seguro
 */
export const generateSecureToken = (length = 32) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  for (let i = 0; i < length; i++) {
    token += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token;
};

/**
 * Gera um token aleatório hexadecimal
 * @param {number} length - Tamanho do token em bytes (padrão: 32)
 * @returns {string} Token em formato hexadecimal
 */
export const generateHexToken = (length = 32) => {
  let token = "";
  for (let i = 0; i < length; i++) {
    token += Math.floor(Math.random() * 16).toString(16);
  }
  return token;
};

/**
 * Gera um token com timestamp e componente aleatório
 * @returns {string} Token com timestamp
 */
export const generateTimestampToken = () => {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 15);
  return `${timestamp}_${randomPart}`;
};

/**
 * Função padrão para gerar token/JWT
 * Retorna um token seguro no formato hexadecimal
 * @returns {string} Token gerado
 */
export const generateToken = () => {
  return generateHexToken(64);
};

export default generateToken;
